"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts 24hrs time to 12 hrs
 * @param timeString eg. 19:30
 * @returns timeString12hr eg. 9:30am
 */
const formatTime = (timeString) => {
    const timeString12hr = new Date(`1970-01-01T${timeString}Z`).toLocaleTimeString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        hour: 'numeric',
        minute: 'numeric',
    });
    return timeString12hr;
};
exports.default = formatTime;
